import React from 'react';
import { StyleSheet, View } from 'react-native';
import { rem } from 'design-system';
import Text from 'design-system/Text';
import { tierThemes } from 'features/premium/benefits';
import { TierPeriod } from 'features/premium/entities';
const periodMap = {
    [TierPeriod.monthly]: 'months',
    [TierPeriod.yearly]: 'years',
};
const Pricing = ({ title, formattedPrices, period, tier }) => (<View style={styles.textContainer}>
    <Text Text-24 centered style={styles.title}>
      {title}
    </Text>
    <Text TextThin-20 centered Secondary style={styles.title}>
      <Text Numbers-20 Primary>
        {formattedPrices.discountedPrice}{' '}
      </Text>
      instead of{' '}
      <Text Numbers-20 OffBlack style={styles.normalPrice}>
        {formattedPrices.originalPrice}
      </Text>
    </Text>
    {formattedPrices.numberOfPeriods > 1 ? (<Text TextThin-16 centered Secondary>
        Enjoy this exclusive price for{'\n'}the first{' '}
        {formattedPrices.numberOfPeriods} {periodMap[period]}.
      </Text>) : (<Text TextThin-16 centered Secondary>
        Keep {tierThemes[tier].name} for just{'\n'}
        {formattedPrices.discountedMonthlyPrice} instead of{' '}
        <Text TextThin-16 Secondary style={styles.normalPrice}>
          {formattedPrices.originalMonthlyPrice}
        </Text>
        .
      </Text>)}
  </View>);
const styles = StyleSheet.create({
    textContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        marginHorizontal: rem(34),
    },
    title: {
        marginBottom: rem(16),
    },
    normalPrice: {
        textDecorationLine: 'line-through',
    },
});
export default Pricing;
